import type { CheckWithLines } from '@accounting/shared';
import { amountToWords } from '@accounting/shared';
import { formatAccountingDate, formatCurrency } from '../../lib/formatters';

export function CheckFace({
  companyName,
  addressLines = [],
  check,
}: {
  companyName: string;
  addressLines?: string[];
  check: CheckWithLines;
}) {
  return (
    <div className="check check-print">
      {check.status === 'voided' && <div className="check-void-stamp">VOID</div>}

      <div className="check-band">
        <div>
          <div className="check-payer">{companyName}</div>
          {addressLines.map((l, i) => (
            <div key={i} className="muted" style={{ fontSize: 11 }}>{l}</div>
          ))}
          <div className="muted" style={{ fontSize: 11, marginTop: 4 }}>
            {check.bankAccountCode} — {check.bankAccountName}
          </div>
        </div>
        <div className="check-no">
          <div>
            No.{' '}
            {check.checkNumber ? (
              <strong>{check.checkNumber}</strong>
            ) : (
              <em className="muted">assigned at print</em>
            )}
          </div>
          <div style={{ marginTop: 6 }}>
            Date <strong>{formatAccountingDate(check.checkDate)}</strong>
          </div>
        </div>
      </div>

      <div className="check-row">
        <span className="check-label">Pay to the<br />order of</span>
        <span className="check-fill">{check.payeeName}</span>
        <span className="check-amount-box">{formatCurrency(check.amount)}</span>
      </div>
      {check.payeeAddress && (
        <div className="muted" style={{ fontSize: 11, marginLeft: 96, marginTop: 2, whiteSpace: 'pre-line' }}>
          {check.payeeAddress}
        </div>
      )}

      <div className="check-words">
        <span className="check-fill">{amountToWords(check.amount)}</span>
        <span className="check-label">Dollars</span>
      </div>

      <div className="check-footer">
        <div style={{ flex: 1 }}>
          <span className="check-label">Memo</span>
          <div className="check-fill" style={{ marginTop: 2 }}>{check.memo ?? ''}</div>
        </div>
        <div className="check-sign">
          <div className="check-sign-line">Authorized signature</div>
        </div>
      </div>
    </div>
  );
}
